var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5" },
          [
            _c(
              "c-search-box",
              { on: { enter: _vm.getList } },
              [
                _c("template", { slot: "search" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                    },
                    [
                      _c("c-plant", {
                        attrs: { type: "search", name: "plantCd" },
                        model: {
                          value: _vm.searchParam.plantCd,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchParam, "plantCd", $$v)
                          },
                          expression: "searchParam.plantCd",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                    },
                    [
                      _c("c-select", {
                        attrs: {
                          comboItems: _vm.useFlagItems,
                          type: "search",
                          itemText: "codeName",
                          itemValue: "code",
                          name: "useFlag",
                          label: "LBLUSEFLAG",
                        },
                        model: {
                          value: _vm.searchParam.useFlag,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchParam, "useFlag", $$v)
                          },
                          expression: "searchParam.useFlag",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
            _c(
              "c-table",
              {
                ref: "table",
                attrs: {
                  title: "배치도면 목록",
                  tableId: "riskHazrd01",
                  columns: _vm.grid.columns,
                  data: _vm.grid.data,
                  filtering: false,
                  columnSetting: false,
                  changeData: _vm.grid.changeData,
                  editable: _vm.editable,
                },
                on: {
                  linkClick: _vm.linkClick,
                  getTableHeight: (height) => {
                    this.imgHeight = height
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "customArea",
                    fn: function ({ props, col }) {
                      return [
                        col.name === "src"
                          ? [
                              _c("q-btn", {
                                attrs: {
                                  round: "",
                                  unelevated: "",
                                  size: "6px",
                                  color: "amber",
                                  icon: "search",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.imageLoad(
                                      props.row,
                                      props.pageIndex
                                    )
                                  },
                                },
                              }),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable
                          ? _c("c-btn", {
                              attrs: { label: "LBLREG", icon: "add" },
                              on: { btnClicked: _vm.add },
                            })
                          : _vm._e(),
                        _c("c-btn", {
                          attrs: { label: "LBLSEARCH", icon: "search" },
                          on: { btnClicked: _vm.getList },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7" },
          [
            _c(
              "c-card",
              {
                staticClass: "cardClassDetailForm",
                attrs: {
                  title: "지도 미리보기",
                  noMarginPadding: true,
                  height: _vm.setImgHeight,
                },
              },
              [
                _c(
                  "template",
                  { slot: "card-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.haveMap
                          ? _c("q-btn", {
                              staticClass: "custom-btn",
                              attrs: {
                                size: "md",
                                "text-color": "white",
                                color: "teal-6",
                                icon: _vm.$q.fullscreen.isActive
                                  ? "fullscreen_exit"
                                  : "fullscreen",
                                label: "지도 크게 보기",
                              },
                              on: { click: _vm.toggle },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("template", { slot: "card-detail" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-img", {
                        ref: "image",
                        attrs: {
                          src: _vm.mapSrc,
                          fit: "scale-down",
                          contain: true,
                          ratio: 1,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "loading",
                            fn: function () {
                              return [
                                _c("q-spinner-gears", {
                                  attrs: { color: "white" },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }